export default "__VITE_ASSET__sfaKhEnA__"